import { Injectable } from '@angular/core';
import { normalizeCoordinateInput } from './parsers/coordinate-input-normalizer';
import { parseDecimalDegrees } from './parsers/dd.parser';
import { parseCardinalPair } from './parsers/cardinal.parser';
import { parseDdmPair } from './parsers/ddm.parser';
import { parseDmsPair } from './parsers/dms.parser';
import { CoordinateValidatorService } from './coordinate-validator.service';
import { ParsedCoordinatePair } from './models/coordinate-search.model';

@Injectable({
  providedIn: 'root',
})
export class CoordinateParserService {
  constructor(private readonly validator: CoordinateValidatorService) {}

  parse(input: string): ParsedCoordinatePair | null {
    if (!input?.trim()) {
      return null;
    }

    if (this.validator.isLikelySingleNumericToken(input)) {
      return null;
    }

    const normalized = normalizeCoordinateInput(input);
    if (!normalized) {
      return null;
    }

    const parsers = [
      () => parseDecimalDegrees(normalized),
      () => parseCardinalPair(normalized),
      () => parseDdmPair(normalized),
      () => parseDmsPair(normalized),
    ];

    for (const run of parsers) {
      const candidate = run();
      if (this.validator.isValidPair(candidate)) {
        return candidate;
      }
    }

    return null;
  }
}
